import { render } from "./BasketButton.vue?vue&type=template&id=0ba7f64d&scoped=true"
import script from "./BasketButton.vue?vue&type=script&lang=js"
export * from "./BasketButton.vue?vue&type=script&lang=js"

import "./BasketButton.vue?vue&type=style&index=0&id=0ba7f64d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba7f64d"]])

export default __exports__